module.exports = __webpack_public_path__ + "9d52c0a552153cf8823845c3d9fab569.svg";